import featureFlags from '../config/featureFlags';

export function track(event, props = {}) {
  try {
    if (!featureFlags.analytics_v1) return;
    if (typeof window !== 'undefined' && window.posthog && typeof window.posthog.capture === 'function') {
      window.posthog.capture(event, props);
    }
  } catch (_) { /* no-op */ }
}